module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiCn.1170ffa.eot";